import { ResponseBase } from '../response-base.model';
export class PreguntaResponse extends ResponseBase {
    idEncuesta: number;
    idSecccion: number;
    idPregunta: number;
    tipoPregunta: number;
}